import React, { useState, useEffect, useRef }  from 'react';
import styles from 'components/quote_builder_widget/_style.module.scss';
import QuoteBuilderForm from 'components/quote_builder_widget/QuoteBuilderForm.jsx';
import ThreeDPreview from 'components/quote_builder_widget/ThreeDPreview.jsx';
import { GetRequest } from 'components/common/index.js';
import { getTheme } from 'components/quote_builder_widget/themes';

const QuoteBuilderWidget = ( { defaultId, theme: themeName = 'default', unitOption = 'both', widgetIdentifier } ) => {
  const [id, setId] = useState(defaultId)
  const theme = getTheme(themeName);
  const myRef = useRef();
  const [drawing, setDrawing] = useState({})
  const publishSize = () => {
    if (drawing.catalog_name === undefined) {
      return;
    }

    if (window.parent !== undefined) {
      const message = {
        type: 'diecuttemplates.iframe_set_size',
        data: {
          identifier: drawing.catalog_name,
          width: String(theme.maxWidth || 800),
        },
      };
      window.parent.postMessage(message, "*");
    }
  }

  const getDrawing = () => {
    // https://diecuttemplates.com.dev/drawing-data/72606
    if(id == null) { return }

    GetRequest({
      url: `/drawing-data/${id}`,
      callback: (data) => {
        setDrawing( () => data.drawing)
      }
    })
  }

  const onDrawingFetched = () => {
    if(drawing.catalog_name == undefined) { return }
    console.log({drawing})
    publishSize();
  }

  // Validation helpers for live preview
  const isValidHexColor = (color) => /^#[0-9a-fA-F]{6}$/.test(color);

  const ALLOWED_FONT_FAMILIES = [
    '',
    'Arial, sans-serif',
    'Helvetica, Arial, sans-serif',
    'Georgia, serif',
    'Verdana, sans-serif',
    'Tahoma, sans-serif',
    '"Trebuchet MS", sans-serif',
    '"Times New Roman", serif',
    '"Courier New", monospace',
    'system-ui, sans-serif',
  ];

  // Listen for style updates from parent window (for live preview)
  const setupStyleUpdateListener = () => {
    const handleMessage = (event) => {
      if (event.data && event.data.type === 'diecuttemplates.update_css') {
        const styleElement = document.getElementById('user-custom-css');
        if (styleElement) {
          styleElement.textContent = event.data.css || '';
        }
      }
      if (event.data && event.data.type === 'diecuttemplates.update_background_color') {
        let styleElement = document.getElementById('widget-background-color');
        if (!styleElement) {
          styleElement = document.createElement('style');
          styleElement.id = 'widget-background-color';
          document.head.appendChild(styleElement);
        }
        // Validate hex color format before applying
        if (event.data.color && isValidHexColor(event.data.color)) {
          styleElement.textContent = `[data-widget-element="layout-container"] { background: ${event.data.color} !important; }`;
        } else {
          styleElement.textContent = '';
        }
      }
      if (event.data && event.data.type === 'diecuttemplates.update_font_family') {
        let styleElement = document.getElementById('widget-font-family');
        if (!styleElement) {
          styleElement = document.createElement('style');
          styleElement.id = 'widget-font-family';
          document.head.appendChild(styleElement);
        }
        // Validate font family is in allowed list before applying
        if (event.data.fontFamily && ALLOWED_FONT_FAMILIES.includes(event.data.fontFamily)) {
          styleElement.textContent = `[data-widget-element="layout-container"] { font-family: ${event.data.fontFamily} !important; }`;
        } else {
          styleElement.textContent = '';
        }
      }
      if (event.data && event.data.type === 'diecuttemplates.update_highlight_color') {
        let styleElement = document.getElementById('widget-highlight-color');
        if (!styleElement) {
          styleElement = document.createElement('style');
          styleElement.id = 'widget-highlight-color';
          document.head.appendChild(styleElement);
        }
        // Validate hex color format before applying
        if (event.data.color && isValidHexColor(event.data.color)) {
          styleElement.textContent = `:root { --dct-highlight-color: ${event.data.color} !important; }`;
        } else {
          styleElement.textContent = '';
        }
      }
    };

    window.addEventListener('message', handleMessage);
    return () => {
      window.removeEventListener('message', handleMessage);
    };
  };

  // useEffect
  useEffect(getDrawing, [id])
  useEffect(onDrawingFetched, [drawing])
  useEffect(setupStyleUpdateListener, [])
  // useEffect

  const Layout = theme.QuoteBuilderLayout;

  return (
    <div ref={myRef}>
      <Layout drawing={drawing}>
        <QuoteBuilderForm
          id={id}
          setId={setId}
          drawing={drawing}
          theme={theme}
          unitOption={unitOption}
          widgetIdentifier={widgetIdentifier}
        />
      </Layout>
    </div>
  );
}

export default QuoteBuilderWidget;
